import React, { useState } from 'react'
import styled from 'styled-components'

const ToggleSwitch = ({checked: checkedProp, onChange, label, id, description}) => {
  const [checked, setChecked] = useState(checkedProp);

  function changeHandler() {
    const newValue = !checked;
    setChecked(newValue);
    onChange(newValue);
  }

  return (
    <Wrapper>
      <ToggleSwitchWrapper
        className={`toggle-switch ${checked ? 'checked' : ''}`}
        onClick={changeHandler}
      >
        <input type="checkbox" defaultChecked={checked} className="toggle-switch-checkbox" name={id} id={id} />
        <Switch />
        <Label className="toggle-switch-label" htmlFor={id}>
          {label}
        </Label>
      </ToggleSwitchWrapper>
      <Description>
        {description}
      </Description>
    </Wrapper>
  );
}

export default ToggleSwitch;

const Wrapper = styled.div``;

const ToggleSwitchWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  cursor: pointer;
  input {
    display: none;
  }
`;

const Label = styled.label`
  font-size: 14px;
  font-weight: 500;
  line-height: 1.2;
  pointer-events: none;
  text-align: left;
  margin: 0;

  span {
    font-weight: 500;
  }
`;

const Switch = styled.div`
  position: relative;
  width: 40px;
  height: 20px;
  background-color: #eaeaea;
  border: 2px solid #bbbbbb;
  flex: 0 0 40px;
  margin-right: 10px;
  border-radius: 12px;
  transition: all 0.3s ease-in-out;

  &:after {
    display: block;
    content: '';
    position: absolute;
    left: -2px;
    top: -2px;
    background-color: #fff;
    width: 20px;
    height: 20px;
    border: 2px solid #bbbbbb;
    border-radius: 100%;
    transition: all 0.3s ease-in-out;
  }

  .checked & {
    background-color: #86b300;
    border: 2px solid #429600;

    &:after {
      left: 18px;
      border: 2px solid #429600;
    }
  }
`;

const Description = styled.p`
  font-size: 12px;
  line-height: 15px;
  margin: .75rem 0 0;
  color: #5F7D95; 
`;


// WEBPACK FOOTER //
// ./src/components/ui/toggle-switch.js